import appConfigurationService from "@/Services/AppConfigurationService";
import $handleError from "@/plugins/handleError";

const state = () => ({
  hikvisionEnabled: false,
  notifiqTabEnabled: false,
  notifiqLancamentoEnabled: false,
  loading: false,
});

const mutations = {
  setLoading(state, value) {
    state.loading = value;
  },
  setHikvisionEnabled(state, value) {
    state.hikvisionEnabled = value;
  },
  setNotifiqTabEnabled(state, value) {
    state.notifiqTabEnabled = value;
  },
  setNotifiqLancamentoEnabled(state, value) {
    state.notifiqLancamentoEnabled = value;
  },
};

const actions = {
  async fetchHikvisionStatus({ commit }) {
    try {
      const response = await appConfigurationService.getHikvisionStatus();
      commit("setHikvisionEnabled", !!response.enabled);
    } catch (error) {
      $handleError(error);
    }
  },
  async toggleHikvision({ commit }, enabled) {
    const response = await appConfigurationService.toggleHikvision(enabled);
    commit("setHikvisionEnabled", !!response.enabled);
  },
  async fetchNotifiqTabStatus({ commit }) {
    try {
      const response = await appConfigurationService.getNotifiqTabStatus();
      commit("setNotifiqTabEnabled", !!response.enabled);
    } catch (error) {
      $handleError(error);
    }
  },
  async toggleNotifiqTab({ commit }, enabled) {
    const response = await appConfigurationService.toggleNotifiqTab(enabled);
    commit("setNotifiqTabEnabled", !!response.enabled);
  },
  async fetchNotifiqLancamentoStatus({ commit }) {
    try {
      const response = await appConfigurationService.getNotifiqLancamentoStatus();
      commit("setNotifiqLancamentoEnabled", !!response.enabled);
    } catch (error) {
      $handleError(error);
    }
  },
  async toggleNotifiqLancamento({ commit }, enabled) {
    const response = await appConfigurationService.toggleNotifiqLancamento(enabled);
    commit("setNotifiqLancamentoEnabled", !!response.enabled);
  },
};

const getters = {
  hikvisionEnabled: (state) => state.hikvisionEnabled,
  notifiqTabEnabled: (state) => state.notifiqTabEnabled,
  notifiqLancamentoEnabled: (state) => state.notifiqLancamentoEnabled,
  loading: (state) => state.loading,
};

const namespaced = true;

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters,
};
